import type { CallBlock } from "~/features/orders/types-order";

type ActiveBlocksProps = Readonly<{
  blocks: CallBlock[];
}>;

export function ActiveBlocks({ blocks }: ActiveBlocksProps) {
  if (blocks.length === 0) return null;

  return (
    <div style={{ marginTop: 24 }}>
      <h3 style={{ fontSize: 14, marginBottom: 8 }}>Active Blocks</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {blocks.map(block => (
          <div key={block.id} style={{ padding: 12, borderRadius: 8, background: "var(--neutral-gray)" }}>
            <div style={{ fontWeight: 600 }}>
              Block #{block.id} · {block.status.toUpperCase()}
            </div>
            <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
              Window {block.time_window.start}:00-{block.time_window.end}:00 · Orders {block.order_ids.length}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
